import React from 'react'
import SimpleEntitiesEditor from '../../../components/simpleEntitiesEditor'

export default ({ entityName }) => <SimpleEntitiesEditor entityName="tagType" entityLabel="Tag Type"/>
